window.kvHideOosRefresh = function kvHideOosRefresh() {
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var hideOos = grid.getAttribute('data-kv-hide-oos') === 'true';
  var filterActive = grid.getAttribute('data-kv-availability-active') === 'true';
  var perPage = parseInt(grid.getAttribute('data-kv-per-page'), 10) || 16;
  var shopifyPages = parseInt(grid.getAttribute('data-kv-shopify-pages'), 10) || 1;
  var sectionId = grid.getAttribute('data-id');

  if (!hideOos || filterActive || shopifyPages <= 1) return;

  var container = document.getElementById('ProductGridContainer');
  var collectionEl = container ? container.querySelector('.collection') : null;
  if (collectionEl) collectionEl.classList.add('loading');

  var parser = new DOMParser();
  var requests = [];
  var pageIndex;

  for (pageIndex = 1; pageIndex <= shopifyPages; pageIndex += 1) {
    requests.push(
      fetch(kvHideOosPageUrl(pageIndex, sectionId)).then(function (response) {
        return response.text();
      })
    );
  }

  Promise.all(requests)
    .then(function (pages) {
      var items = [];
      pages.forEach(function (html) {
        var doc = parser.parseFromString(html, 'text/html');
        var pageGrid = doc.getElementById('product-grid');
        if (!pageGrid) return;
        Array.prototype.forEach.call(pageGrid.children, function (node) {
          items.push(node);
        });
      });

      window.kvHideOosItems = items;
      kvHideOosRenderPage(kvHideOosCurrentPage(), perPage);
    })
    .finally(function () {
      if (collectionEl) collectionEl.classList.remove('loading');
    });
};

function kvHideOosPageUrl(page, sectionId) {
  var params = new URLSearchParams(window.location.search);
  params.set('page', String(page));
  params.set('section_id', sectionId);
  params.delete('kv_page');
  return window.location.pathname + '?' + params.toString();
}

function kvHideOosCurrentPage() {
  var params = new URLSearchParams(window.location.search);
  return parseInt(params.get('kv_page') || '1', 10) || 1;
}

function kvHideOosRenderPage(page, perPage) {
  var grid = document.getElementById('product-grid');
  var items = window.kvHideOosItems || [];
  if (!grid) return;

  var total = items.length;
  var totalPages = Math.max(1, Math.ceil(total / perPage));
  if (page > totalPages) page = totalPages;
  if (page < 1) page = 1;

  var start = (page - 1) * perPage;
  var slice = items.slice(start, start + perPage);

  grid.innerHTML = '';
  slice.forEach(function (node) {
    grid.appendChild(document.importNode(node, true));
  });

  kvHideOosRenderPagination(page, totalPages);
  kvHideOosUpdateCount(total);
}

function kvHideOosRenderPagination(page, totalPages) {
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var existing =
    container.querySelector('.kv-native-pagination') || container.querySelector('.pagination-wrapper');
  if (totalPages <= 1) {
    if (existing) existing.remove();
    return;
  }

  var html = ['<div class="pagination-wrapper kv-pagination-wrapper">'];
  html.push('<nav class="pagination" role="navigation">');
  html.push('<ul class="pagination__list list-unstyled" role="list">');

  if (page > 1) {
    html.push(
      '<li><a href="#" data-kv-page="' +
        (page - 1) +
        '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"><span class="svg-wrapper">' +
        kvHideOosCaret() +
        '</span></a></li>'
    );
  }

  var i;
  for (i = 1; i <= totalPages; i += 1) {
    if (i === page) {
      html.push(
        '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">' +
          i +
          '</a></li>'
      );
    } else {
      html.push(
        '<li><a href="#" data-kv-page="' + i + '" class="pagination__item link">' + i + '</a></li>'
      );
    }
  }

  if (page < totalPages) {
    html.push(
      '<li><a href="#" data-kv-page="' +
        (page + 1) +
        '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><span class="svg-wrapper">' +
        kvHideOosCaret() +
        '</span></a></li>'
    );
  }

  html.push('</ul></nav></div>');

  if (existing) {
    existing.outerHTML = html.join('');
  } else {
    var collectionEl = container.querySelector('.collection');
    if (collectionEl) collectionEl.insertAdjacentHTML('beforeend', html.join(''));
  }

  container.querySelectorAll('.kv-pagination-wrapper a[data-kv-page]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var nextPage = parseInt(link.getAttribute('data-kv-page'), 10);
      var params = new URLSearchParams(window.location.search);
      params.set('kv_page', String(nextPage));
      params.delete('page');
      history.pushState({}, '', window.location.pathname + '?' + params.toString());
      kvHideOosRenderPage(nextPage, parseInt(document.getElementById('product-grid').getAttribute('data-kv-per-page'), 10) || 16);
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function kvHideOosCaret() {
  var caret = document.querySelector('.pagination__item-arrow .svg-wrapper');
  return caret ? caret.innerHTML : '';
}

function kvHideOosUpdateCount(total) {
  var countEl = document.querySelector('.collection-product-count span');
  if (!countEl) return;

  var label = countEl.textContent.replace(/^\s*\d+\s*/, '');
  countEl.textContent = total + (label ? ' ' + label : '');
}

document.addEventListener('DOMContentLoaded', function () {
  window.kvHideOosRefresh();
});
